export default "__VITE_ASSET__beb9d0d7__"